import { ReactComponent as Triangle } from 'assets/warningTriangle.svg'
import React from 'react'

/** alert wyświetlany na grafice bramy / furtki (awaria, alerty najmu) */
const GateAlert: React.FC<warehouse.WarehouseAlert> = ({ title, desc, warning, buttonText, action }) => (
  <div className={`gateGateway__popup --alert${warning ? ' --warning' : ''}`} role='alert'>
    <div className='popup__title'>
      {warning && <Triangle />}
      <div className='--secFont'>{title}</div>
      <div>{desc}</div>
    </div>
    {action && <div
      className='popup__button --secFont'
      onClick={e => {
        action()
        e.stopPropagation()
      }}>
      {buttonText}
    </div>}
  </div>
)

export default GateAlert
